<template>
  <div>
    <p>{{ labels.getMoreFromTeamCulture }}</p>
    <div class="plans">
      <div class="plan-item">
        <b-card class="shadow-active">
          <h3>
            <span>{{ basic.name }}</span>
            <i class="mdi mdi-check-circle text-lima"></i>
          </h3>

          <div class="price">
            <div>
              R$ 0,00<small>/{{ labels.month }}*</small>
            </div>
          </div>

          <p class="per-user">
            {{ labels.basicUsersQuantity }}
          </p>

          <ul class="features">
            <li v-for="feature in basic.features" :key="feature">
              {{ feature }}
            </li>
          </ul>
        </b-card>
      </div>

      <div class="plan-item">
        <b-card>
          <h3>{{ enterprise.name }}</h3>
          <div class="price">
            <small>{{ enterprise.monthly }}/{{ labels.month }}*</small>
            <div>
              {{ enterprise.annuity }}<small>/{{ labels.month }}**</small>
            </div>
          </div>

          <p class="per-user">
            *{{ labels.byUser }} <br />
            **{{ labels.byUserInYear }}
          </p>

          <ul class="features">
            <li v-for="feature in enterprise.features" :key="feature">
              {{ feature }}
            </li>
          </ul>

          <div class="text-center">
            <b-button
              class="get-plan"
              variant="red02"
              @click="enterprisePlanClick"
              >{{ labels.getBusinessPlan }}</b-button
            >
          </div>
        </b-card>
      </div>

      <div class="plan-item">
        <b-card>
          <h3>{{ labels.custom }}</h3>
          <div class="price">
            <div>{{ labels.contactUs }}</div>
          </div>

          <p class="per-user">{{ labels.moreThen1000 }}</p>

          <div>
            <address class="text-left text-primary">
              axel@teamculture.com.br
              <br />
              (11) 3147-1717
            </address>
            <!-- <b-button class="get-plan" variant="red02" href="mailto:">{{labels.contact}}</b-button> -->
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

function toCurrency(num) {
  return num
    .toFixed(2)
    .replace('.', ',')
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

function getBreadcrumb(labels) {
  const breadcrumb = [
    {
      label: labels.account,
      link: '/account',
    },
    {
      label: labels.plans,
    },
  ]

  return breadcrumb
}

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
      plans: 'account/plans',
    }),

    labels: function() {
      return Object.assign(
        {},
        this.resources.general.menu,
        this.resources.page.home.accountGeneric,
        this.resources.page.home.accountPlans
      )
    },

    basic: function() {
      const plan = this.plans[0] || {
        name: this.labels.basic,
        minUser: 3,
        maxUser: 11,
        features: [],
      }

      return { ...plan, name: this.labels.basic }
    },
    enterprise: function() {
      const plan = this.plans[1] || {
        name: this.labels.enterprise,
        prices: [{ pricePerUser: 8.9 }, { pricePerUser: 5.9 }],
        features: [],
      }

      return {
        name: this.labels.enterprise,
        monthly: `R$ ${toCurrency(plan.prices[0].pricePerUser)}`,
        annuity: `R$ ${toCurrency(plan.prices[1].pricePerUser)}`,
        features: plan.features,
      }
    },
  },

  methods: {
    enterprisePlanClick() {
      this.$root.$emit('track', {
        event: 'Clicou em obter empresarial',
        data: {
          category: 'Upgrade',
        },
      })

      this.$router.push({
        name: 'account.licenses',
        params: { period: 'monthly' },
      })
    },
  },

  mounted() {
    const breadcrumb = getBreadcrumb(this.labels)
    this.$store.dispatch('account/loadPlans')
    this.$root.$emit('set-breadcrumb', breadcrumb)
    this.$root.$emit('setPageTitle', { context: this, path: 'account/plans' })
    this.$root.$emit('track', {
      event: 'Acessou pagina de planos',
      data: {
        category: 'Checkout',
      },
    })
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

p {
  color: map-get($theme-colors, 'gray03');
}

.plans {
  display: flex;
  flex-direction: row;

  @media (max-width: '425px') {
    flex-direction: column;
  }

  .plan-item {
    flex-basis: 33%;
    margin: 0.4rem;

    @media (max-width: '425px') {
      margin: 0.25rem;
    }

    .card-body {
      padding: 1rem;
    }

    .shadow-active {
      .card-body {
        box-shadow: 0 0 38px rgba(61, 90, 254, 0.25);
      }
    }

    h3 {
      align-items: center;
      color: map-get($theme-colors, 'primary');
      display: flex;
      font-size: 18px;
      font-weight: 500;
      justify-content: space-between;
      margin: 0 0 0.6rem;
      text-transform: uppercase;

      .mdi-check-circle {
        font-size: 1.4rem;
      }
    }

    .price {
      color: map-get($theme-colors, 'red02');
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.8rem;

      small {
        font-weight: 500;
        font-size: 1rem;
      }
    }

    .per-user {
      color: map-get($theme-colors, 'quartenary');
      font-weight: 500;
      line-height: initial;
      margin-top: 10px;
    }

    .features {
      color: map-get($theme-colors, 'septenary');
    }
  }
}
</style>
